import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Plus, Trash, EnvelopeSimple, UserCircle } from "@phosphor-icons/react";

export default function Accountants() {
  const [list, setList] = useState([]);
  const [form, setForm] = useState({ email: "", name: "" });
  const [busy, setBusy] = useState(false);

  const load = useCallback(async () => { const r = await api.get("/accountants"); setList(r.data); }, []);
  useEffect(() => { load(); }, [load]);

  const invite = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/accountants/invite", form);
      setForm({ email: "", name: "" }); load();
    } catch (e) { alert(e?.response?.data?.detail || e.message); }
    finally { setBusy(false); }
  };

  const del = async (id) => {
    if (!confirm("Revoke access?")) return;
    await api.delete(`/accountants/${id}`); load();
  };

  return (
    <div className="space-y-8">
      <div>
        <div className="eyebrow mb-2">Accountant Portal</div>
        <h1 className="font-display text-4xl">Invite your accountant</h1>
        <p className="text-white/60 text-sm mt-2">Grant read-only access. Every action logged with GDPR consent trace.</p>
      </div>

      <form onSubmit={invite} className="glass rounded-xl p-6 grid grid-cols-1 md:grid-cols-3 gap-4 items-end">
        <div><label>Accountant name</label><input value={form.name} onChange={e => setForm({...form, name: e.target.value})} placeholder="e.g. Aoife O'Brien" data-testid="input-acc-name"/></div>
        <div><label>Email</label><input required type="email" value={form.email} onChange={e => setForm({...form, email: e.target.value})} placeholder="accountant@firm.ie" data-testid="input-acc-email"/></div>
        <button type="submit" disabled={busy} data-testid="btn-invite" className="btn-gold justify-center"><Plus weight="bold" size={16}/> Send invite</button>
      </form>

      <div className="glass rounded-xl overflow-hidden">
        {list.length === 0 ? (
          <div className="p-12 text-center text-white/50 text-sm">No accountants invited yet.</div>
        ) : (
          <table className="data">
            <thead><tr><th>Name</th><th>Email</th><th>Status</th><th>Invited</th><th></th></tr></thead>
            <tbody>
              {list.map(a => (
                <tr key={a.invite_id}>
                  <td className="flex items-center gap-2"><UserCircle size={18} weight="duotone" color="#FFB020"/>{a.accountant_name || "—"}</td>
                  <td className="text-white/70">{a.accountant_email}</td>
                  <td><span className="badge-warn px-2 py-0.5 rounded-full text-[10px] uppercase tracking-wider">{a.status}</span></td>
                  <td className="mono text-xs text-white/50">{a.created_at?.slice(0,10)}</td>
                  <td className="text-right">
                    <button onClick={() => del(a.invite_id)} className="text-white/40 hover:text-[#E63946]" data-testid={`btn-del-acc-${a.invite_id}`}><Trash size={16}/></button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
